export const leadSourceOptions = [
  { label: "Google Search", value: "Google" },
  { label: "Facebook", value: "Facebook" },
  { label: "Instagram", value: "Instagram" },
  { label: "LinkedIn", value: "LinkedIn" },
  { label: "Yahoo", value: "Yahoo" },
  { label: "Twitter", value: "Twitter" },
  { label: "Square Meal", value: "Square_Meal" },
  { label: "Referral", value: "Referral" },
  { label: "AI", value: "AI" },
  { label: "Previous Client", value: "Previous_Client" },
  { label: "Friend", value: "Friend" },
  { label: "Other", value: "Other" },
] as const;

const leadSourceLabels: Record<string, string> = {
  ...Object.fromEntries(
    leadSourceOptions.map((option) => [option.value, option.label]),
  ),
  "Yahoo,": "Yahoo",
};

export const formatLeadSource = (value?: string | null) => {
  const raw = String(value ?? "").trim();
  if (!raw || raw === "-") return "-";
  return leadSourceLabels[raw] || raw.replace(/_/g, " ");
};
